<!-- 获取车辆身份 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carCode":"粤B81327",
                "enterTime" : "2018-06-01 09:27:16",
                "leaveTime" : "2018-06-06 14:52:06",
                "parkCode" : "2KKN6112",
                "parkingCode" : "180601092716185686902361",
                "leaveChannelId" : "",
                "enterChannelId" : ""
            },
            responseCode: {
                "data": {
                    "normalCarTimePeriod": {
                        "beginTime": "2018-08-08 03:23:58.277Z",
                        "endTime": "2018-08-08 03:23:58.277Z"
                    },
                    "vipCarTimePeriodList": [{
                            "beginTime": "2018-08-08 03:23:58.277Z",
                            "endTime": "2018-08-08 03:23:58.277Z",
                            "groupCode": "string",
                            "needCharge": false
                        }]
                    },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "获取车辆身份",
                t_url: this.commonUrls.test+"getVipByCarNo",
                p_url: this.commonUrls.prod+"getVipByCarNo",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌编号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间yyyy-MM-dd HH:mm:ss' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '查费时间yyyy-MM-dd HH:mm:ss' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水号' },
                        { info1: 'enterChannelId', info2: '否', info3: 'Long', info4: '进场通道Id' },
                        { info1: 'leaveChannelId', info2: '否', info3: 'Long', info4: '出场通道Id' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'normalCarTimePeriod', info2: '是', info3: 'JSONArray', info4: '临时车时间段' },
                        { info1: 'vipCarTimePeriodList', info2: '是', info3: 'JSONArray', info4: 'VIP时间段列表' }
                        ]
                },{
                    titleName: 'vipCarTimePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'beginTime', info2: '是', info3: 'String', info4: '开始时间yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间yyyy-MM-dd HH:mm:ss' },
                        { info1: 'groupCode', info2: '否', info3: 'String', info4: '计费组编号' },
                        { info1: 'needCharge', info2: '是', info3: 'Bool', info4: '时段是否需要计费' }
                        ]
                },{
                    titleName: 'normalCarTimePeriod',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'beginTime', info2: '是', info3: 'String', info4: '开始时间yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getVipByCarNo.vue